<template>
  <div class="pa-2">
    <!-- <div id="containerFinanceGraph" style="height: 300px"></div> -->

    <v-row>
      <v-col md="6" cols="12">
        <v-card class="pa-3">
          <div class="text-h6 mb-2 text-bold text-uppercase">{{ mainStore.module.base}} - {{ mainStore.module.nom }}</div>
          <!-- <v-row>
            <v-col cols="12" md="6">
              <div class="font-weight-bold"><v-icon class="mr-2" size="x-large" icon="mdi-account-edit" color="primary-dark"></v-icon>Nombre d'inscriptions</div>
            </v-col>
            <v-col cols="12" md="6">
              <div class="text-h5 font-weight-bold text-right">{{ finances.nb_inscriptions }}</div>
            </v-col>
          </v-row> -->
          <v-divider style="margin: 5px 0 !important"></v-divider>
          <v-row>
            <v-col cols="12" md="6">
              <div class="font-weight-bold"><v-icon class="mr-2" size="x-large" icon="mdi-credit-card-refund"
                  color="primary-dark"></v-icon>Nombre de remboursements</div>
            </v-col>
            <v-col cols="12" md="6">
              <div class="text-h5 font-weight-bold text-right">{{ finances.nb_remboursements }}</div>
            </v-col>
          </v-row>
          <v-divider style="margin: 5px 0 !important"></v-divider>
          <v-row>
            <v-col cols="12" md="6">
              <div class="font-weight-bold"><v-icon class="mr-2" size="x-large" icon="mdi-credit-card"
                  color="primary-dark"></v-icon>Total CB</div>
            </v-col>
            <v-col cols="12" md="6">
              <div class="text-h5 font-weight-bold text-right text-green-darken-4">{{ total_cb_orga }}<span
                  class="text-h6">€</span></div>
            </v-col>
          </v-row>
          <v-divider style="margin: 5px 0 !important"></v-divider>

          <v-row>
            <v-col cols="12" md="6">
              <div><v-icon class="mr-2 ml-4" size="x-large" icon="mdi-shoe-sneaker" color="primary-dark"></v-icon>Total
                inscriptions sportives</div>
            </v-col>
            <v-col cols="12" md="6">
              <div class="text-h6 text-right">{{ parseFloat(finances.total_ins) }}<span class="text-h6">€</span></div>
            </v-col>
          </v-row>
          <v-divider style="margin: 5px 0 !important"></v-divider>
          <v-row>
            <v-col cols="12" md="6">
              <div><v-icon class="mr-2 ml-4" size="x-large" icon="mdi-silverware-fork-knife"
                  color="primary-dark"></v-icon>Total des options/activités</div>
            </v-col>
            <v-col cols="12" md="6">
              <div class="text-h6 text-right">{{ parseFloat(finances.total_options) }}<span class="text-h6">€</span>
              </div>
            </v-col>
          </v-row>
          <v-divider style="margin: 5px 0 !important"></v-divider>
          <v-row>
            <v-col cols="12" md="6">
              <div><v-icon class="mr-2 ml-4" size="x-large" icon="mdi-handshake" color="primary-dark"></v-icon>Total des
                donations</div>
            </v-col>
            <v-col cols="12" md="6">
              <div class="text-h6 text-right">{{ parseFloat(finances.total_don) }}<span class="text-h6">€</span></div>
            </v-col>
          </v-row>

          <v-divider style="margin: 5px 0 !important"></v-divider>
          <v-row>
            <v-col cols="12" md="6">
              <div class="font-weight-bold"><v-icon class="mr-2" size="x-large" icon="mdi-credit-card-refund"
                  color="primary-dark"></v-icon>Total des remboursements</div>
            </v-col>
            <v-col cols="12" md="6">
              <div class="text-h5 font-weight-bold text-right text-red-darken-4">-{{
                parseFloat(finances.total_remboursements) + parseFloat(finances.total_frais_remboursements) }}<span
                  class="text-h6">€</span></div>
              <div class="text-subtitle-2 font-weight-bold text-right text-red-darken-4">(dont {{
                finances.total_frais_remboursements }}€ de frais)</div>
            </v-col>
          </v-row>
          <v-divider :thickness="3" class="border-opacity-75" style="margin: 5px 0 !important"></v-divider>
          <v-row>
            <v-col cols="12" md="6">
              <div><v-icon class="mr-2" size="x-large" icon="mdi-file-document-edit" color="primary-dark"></v-icon>Total
              </div>
            </v-col>
            <v-col cols="12" md="6">
              <div class="text-h6 text-right">{{ parseFloat(total_a_retroceder) }}<span class="text-h6">€</span>
              </div>
            </v-col>
          </v-row>
          <v-divider style="margin: 5px 0 !important"></v-divider>
          <v-row>
            <v-col cols="12" md="6">
              <div><v-icon class="mr-2" size="x-large" icon="mdi-file-document-edit"
                  color="primary-dark"></v-icon>Montant déjà rétrocédé</div>
            </v-col>
            <v-col cols="12" md="6">
              <div class="text-h6 text-right">{{ parseFloat(finances.retrocede) }}<span class="text-h6">€</span></div>
            </v-col>
          </v-row>
          <v-divider style="margin: 5px 0 !important"></v-divider>
          <v-row>
            <v-col cols="12" md="6">
              <div class="font-weight-bold"><v-icon class="mr-2" size="x-large" icon="mdi-file-document-edit"
                  color="primary-dark"></v-icon>Montant restant à rétroceder</div>
            </v-col>
            <v-col cols="12" md="6">
              <div class="text-h5 font-weight-bold text-right">{{ restant_a_retroceder }}<span class="text-h6">€</span>
              </div>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";

import AdminService from "@/services/admin.service";
export default {
  data() {
    return {
      finances: {},
      categories: [],
    };
  },
  computed: {
    ...mapStores(useMainStore),
    restant_a_retroceder() {
      let restant = parseFloat(this.total_a_retroceder) - parseFloat(this.finances.retrocede);
      return restant.toFixed(2);
    },
    total_a_retroceder() {
      let total = 0;
      total = parseFloat(this.finances.total_cb_without_taxes) - parseFloat(this.finances.total_gia) - parseFloat(this.finances.total_remboursements) - parseFloat(this.finances.total_frais_remboursements);
      return total.toFixed(2);
    },
    total_cb_orga() {
      let total = 0;
      total = parseFloat(this.finances.total_cb_without_taxes) - parseFloat(this.finances.total_gia);
      return total.toFixed(2);
    },
    total_inscription() {
      let total = 0;
      for (let item in this.finances.inscriptions) {
        total += parseFloat(this.finances.inscriptions[item].total);
      }
      return total;
    },
    total_option() {
      let total = 0;
      for (let item in this.finances.options) {
        total += parseFloat(this.finances.options[item].total);
      }
      return total;
    },
    total_remboursement_with_tax() {
      if (this.finances.refunds.quantite != 0) {
        return parseFloat(this.finances.refunds.total) + parseFloat(this.finances.refunds.quantite);
      }
      return 0;
    },
  },
  methods: {
    async get() {
      let req = await AdminService.getFinances(this.mainStore.module.base);
      if (req) {
        this.finances = req.finances;
      }
    },
  },
  async created() {
    await this.get();
  },
};
</script>

<style lang="scss" scoped></style>